module.exports = __webpack_public_path__ + "img/face-grin-stars.8374cf31.svg";